import { render, staticRenderFns } from "./CustomerRecords.vue?vue&type=template&id=385eb7a8&"
import script from "./CustomerRecords.vue?vue&type=script&lang=js&"
export * from "./CustomerRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports